import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import { Button, Container } from "reactstrap";
import RiskTitle from "./RiskTitle";
import doctorConsult from '../../../assets/images/drconsultation-banner.jpeg';
import dietBanner from '../../../assets/images/diet-plan-banner-v2.png';
import { AppContext } from "../../../context/app-context";
import { onFinishedRiskWebView, sendFirebaseEvent } from "../../../helper/mobile";
import { getAge } from "../../../helper";

const YourScore = () => {
    const [state, dispatch] = useContext(AppContext);
    const data = state.riskAssessment.preRiskAssessment;
    const user = state.user;
    const country = localStorage.getItem('country');
    let URL= `userId=${user.id}&groupId=${user.id}&name=${user.fullName}&gender=${user.gender}&age=${getAge(user.dob)} years old&height=${user.height}&width=${user.weight}&token=${user.token}&appVersion=${user.appVersion}&appVersionCode=${user.appVersionCode}&osType=${user.osType}`;
    const consultURL = '/?'+URL;
    const dietPlanURL = `/dietPlan/?token=${user.token}&appVersion=${user.appVersion}&appVersionCode=${user.appVersionCode}&osType=${user.osType}`;

    const onClickHandlerDone = () => {
        sendFirebaseEvent('ra_done_btn_click', 'click_event');
        onFinishedRiskWebView();
    }
    
    return(
        <>
            <div className="your-score-header">
                <Link to="/riskAssessment/measure" className="link float-end measure-link">How we measure?</Link>
                <h3 className="mt-0 mb-0 result-title">Your results</h3>
            </div>
            <Container className="your-score">
                <RiskTitle score={data?.assessmentScore} />
                {country !== 'ae' && 
                    <div className="mt-4 text-center">
                        {/* <Link to={dietPlanURL}>
                            <img src={dietBanner} className="score-diet-banner mb-3" alt="" />
                        </Link> */}
                        {/* <Link to={consultURL}>
                            <img src={doctorConsult} className="score-diet-banner" alt="" />
                        </Link> */}
                    </div>
                }
                
                <div className="empty-space-82"></div>
                <div className="fix-div-button">
                    <Button className="risk-btn" onClick={onClickHandlerDone}>Done</Button>
                </div>
            </Container>
        </>
    )
}

export default YourScore
